<app-nav-menu></app-nav-menu>
<div class="main">
  <div class="container-fluid">
    <div class="cardSize">
      <div class="cms_heading">
        <img style="max-height: 25px; max-width: 25px" src="assets/img/itinerary-64.png" alt="Booking List" />
        <span class="cms_h1">Booking List</span>
      </div>
      <form>
        <div class="row m-0 align-items-center">
          <div class="col-lg-4 col-md-4 col-sm-6 mb-3 mb-md-0 form-field-col">
            <ng-select #agency [items]="agencyCodeList$ | async" name="Agency" bindLabel="labelName"
              bindValue="code" [searchable]="true" [ngModelOptions]="{standalone: true}"
              [(ngModel)]="bookingNew.agencyId" placeholder="Search Agency_Branch" class="agency-select">
            </ng-select>
            <label class="inputFields" for="label">By Agency</label>
          </div>

          <div class="col-lg-3 col-md-3 col-sm-6 mb-3 mb-md-0 form-field-col">
            <!-- From date -->
            <input type="date" class="form-control" name="fromBookingDate" [(ngModel)]="bookingNew.fromBooking">
            <label for="fromDate" class="inputFields">Booking From</label>
          </div>

          <div class="col-lg-3 col-md-3 col-sm-6 mb-3 mb-md-0 form-field-col">
            <!-- To date -->
            <input type="date" class="form-control" name="toBookingDate" [(ngModel)]="bookingNew.toBooking">
            <label for="toDate" class="inputFields">Booking To</label>
          </div>

          <div class="col-lg-2 col-md-2 col-sm-6 form-field-col">
            <button (click)="AgencyCodeChange()" class="LoadButton" type="button">
              Load
              <span class="load loading"></span>
            </button>
          </div>
        </div>
      </form>
    </div>

    <div class="cms_tabel">
      <dx-data-grid #listGrid [dataSource]="bookingList" [showBorders]="true" [showRowLines]="true"
        (onContentReady)="contentReady($event)" [columnAutoWidth]="true">
        <dxo-scrolling mode="standard" [useNative]="true"></dxo-scrolling>
        <dxo-paging [pageSize]="15"></dxo-paging>
        <dxo-pager [showPageSizeSelector]="true" [allowedPageSizes]="[50, 100]"></dxo-pager>
        <dxi-column dataField="bookingDate" alignment="center" caption="Booking Date"></dxi-column>
        <dxi-column [visible]="false" dataField="bookingID" alignment="center" caption="Booking ID"></dxi-column>
        <dxi-column dataField="agencyId" alignment="center" caption="Booking ID"></dxi-column>
        <dxi-column dataField="supplier" alignment="center" caption="Supplier"></dxi-column>
        <dxi-column dataField="pnr" alignment="center" caption="PNR"></dxi-column>
        <dxi-column dataField="tkt" alignment="center" caption="TKT"></dxi-column>
        <dxi-column dataField="trip" alignment="center" caption="Trip"></dxi-column>
        <dxi-column dataField="name" alignment="center" caption="Name"></dxi-column>
        <dxi-column dataField="travelDate" alignment="center" caption="Travel Date"></dxi-column>
        <dxi-column dataField="bookingStatus" alignment="center" caption="Status"></dxi-column>
        <dxi-column caption="Action" [allowSorting]="false" alignment="center"
          cellTemplate="actionCellTemplate"></dxi-column>
        <dxo-search-panel [visible]="true"></dxo-search-panel>

        <div *dxTemplate="let data of 'actionCellTemplate'">
          <a (click)="Edit_Click(data.data)" class="manage-btn"><i class="uil uil-edit"></i> <span>Manage</span></a>
        </div>
      </dx-data-grid>
    </div>
  </div>


  <!--==================================POP UP STRUCTURE=============================================-->
  <!--<ng-template #content let-modal>
    <div class="modal-header">
      <h4 class="modal-title"
          id="modal-basic-title">
        Fare Rules
      </h4>
      <button type="button" class="close"
              aria-label="Close" (click)="modal.dismiss('Cross click')">

        <span aria-hidden="true">
          ×
        </span>
      </button>
    </div>
    <div class="modal-body">
      <div>
        <div class="form-group">
          <div>
            <span class="pop_t_dest">DXB To LHE</span>
          </div>
          <div class="container">
            <div class="pop_table_header d-flex justify-content-between">
              <div></div>
              <div class="pop_table_head_pax"><span class="items_heading_pax">Adult</span><span class="items_heading_pax">Child</span><span class="items_heading_pax">Infant</span></div>
            </div>
            <div class="">
              <div class="pop_card_heading">Changes/Reissue</div>
              <div class="sub_container">
                <div class="items_container">
                  <div class="items_heading">Before Departure</div>
                  <div class="items_heading">After Departure</div>
                </div>

                <div class="paxTypes_container">
                  <div class="pop_table_head"><span class="items_heading_sub_pax">100</span><span class="items_heading_sub_pax">75</span><span class="items_heading_sub_pax">50</span></div>
                  <div class="pop_table_head"><span class="items_heading_sub_pax">Non Changeable</span><span class="items_heading_sub_pax">Changeable</span><span class="items_heading_sub_pax">Changeable</span></div>
                </div>
              </div>
              <div class="note_heading">*K3 & RAF charges extra</div>
            </div>

            <hr />

            <div class="">
              <div class="pop_card_heading">Cancel Penalty</div>
              <div class="sub_container">
                <div class="items_container">
                  <div class="items_heading">Before Departure</div>
                  <div class="items_heading">After Departure</div>
                </div>

                <div class="paxTypes_container">
                  <div class="pop_table_head"><span class="items_heading_sub_pax">150</span><span class="items_heading_sub_pax">100</span><span class="items_heading_sub_pax">50</span></div>
                  <div class="pop_table_head"><span class="items_heading_sub_pax">Non Changeable</span><span class="items_heading_sub_pax">Changeable</span><span class="items_heading_sub_pax">Changeable</span></div>
                </div>
              </div>
              <div class="note_heading">*K3 & RAF charges extra</div>
            </div>

            <hr />

            <div class="">
              <div class="pop_card_heading">ATO Service Fee</div>
              <div class="sub_container">
                <div class="items_container">
                  <div class="items_heading">Refund Service Fee</div>
                </div>

                <div class="paxTypes_container">
                  <div class="pop_table_head"><span class="items_heading_sub_pax">.....</span><span class="items_heading_sub_pax">.....</span><span class="items_heading_sub_pax">.....</span></div>
                </div>
              </div>
              <div class="note_heading">*K3 & RAF charges extra</div>
            </div>

            <hr />


          </div>
        </div>
      </div>
    </div>
  </ng-template>

  <button class="btn btn-sm btn-secondary" (click)="open(content)">
    Fare Rules
  </button>

  <hr />-->




</div>